var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.671,
    height: 34,
    viewBox: "0 0 32.671 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:#5e5e5e}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home",
    transform: "translate(.001 -46.994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-.001 46.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M77.37 120.939l-11.652 9.606a.275.275 0 0 1-.01.061.277.277 0 0 0-.01.06v9.727a1.316 1.316 0 0 0 1.3 1.3h7.781v-7.782h5.188v7.782h7.781a1.317 1.317 0 0 0 1.3-1.3v-9.727a.285.285 0 0 0-.02-.121z",
    className: "cls-1",
    "data-name": "Path 6",
    transform: "translate(-61.035 -115.691)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M32.445 59.66l-4.438-3.688V47.7a.625.625 0 0 0-.649-.648h-3.89a.624.624 0 0 0-.648.648v3.952l-4.944-4.134a2.514 2.514 0 0 0-3.08 0L.225 59.66A.589.589 0 0 0 0 60.1a.656.656 0 0 0 .142.476l1.256 1.5a.691.691 0 0 0 .426.223.753.753 0 0 0 .487-.142l14.024-11.698 14.023 11.693a.625.625 0 0 0 .426.141h.061a.692.692 0 0 0 .426-.223l1.257-1.5a.656.656 0 0 0 .141-.477.59.59 0 0 0-.224-.433z",
    className: "cls-1",
    "data-name": "Path 7",
    transform: "translate(.001 -46.994)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.a444eddce43eb92400a82a28e8b7c742.svg";
export { ForwardRef as ReactComponent };